import { createMuiTheme } from '@material-ui/core';
//extra css
import 'react-perfect-scrollbar/dist/css/styles.css';
import './index.scss';
import overrides from './overrides';

import { palette } from './palette';
import typography from './typography';

const theme = createMuiTheme({
  palette,
  typography,
  overrides,
  zIndex: {
    appBar: 1200,
    drawer: 1100
  }
});

export default theme;
